/**
 * Get all filters configured through a WS Form
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {HTMLElement} parent
 * @returns string|false
 */
export function getWsFormFilters(parent) {
    const filterElements = parent.querySelectorAll('[class*="ct-filter-"]');

    if (filterElements) {
        const filters = {};

        filterElements.forEach((el) => {
            // turn the classlist into an array
            const classes = [].slice.call(el.classList);
            const prefix = 'ct-filter-';
            // Use the array find method to return the class which starts with the prefix as string
            const filterClass = classes.find((aClass) => aClass.startsWith(prefix));
            // The filter name is the class without the prefix
            const filterName = filterClass && filterClass !== '' ? filterClass.substring(prefix.length) : '';
            let filterValue = '';

            if (el.nodeName === 'INPUT' && (el.type === 'radio' || el.type === 'checkbox')) {
                if (el.checked) {
                    filterValue = el.value;
                }
            } else if (el.nodeName === 'SELECT') {
                filterValue = Array.prototype.map.call(el.selectedOptions, (x) => {
                    return x.value;
                });
            } else {
                filterValue = el.value;
            }

            if (filterValue && filterValue !== '') {
                filters[filterName] = filters[filterName] || [];
                filters[filterName] = filters[filterName].concat(filterValue);
            }
        });

        const paramString = new URLSearchParams(filters).toString();
        if (paramString !== '') {
            return paramString;
        }
    }

    return false;
}
